import styled from "styled-components";

export const Actions = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  & > * {
    & + *:not(:first-child) {
      margin-left: 10px;
    }
  }
`;
